export default function ScrollToTop() {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={handleScrollToTop}
      className="fixed bottom-8 right-8 w-12 h-12 flex items-center justify-center rounded-full bg-background-200/80 backdrop-blur-sm border border-background-300/60 text-foreground-300 hover:text-foreground-50 hover:bg-background-300 transition-all duration-200 z-40 cursor-pointer"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}